

















import { defineComponent } from '@vue/composition-api';
import PromptBar from '@getaccept/lib-shared/src/prompt-bar/PromptBar.vue';

export default defineComponent({
  components: {
    PromptBar,
  },
});
